export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
          移动观看
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto">
          榴莲视频全面适配移动端浏览，无论您使用手机还是平板，都能获得流畅的高清影视观看体验。苹果视频、91视频网站、豆花视频、菠萝视频等站点内容均已针对移动端优化，随时随地畅享视频播放。
        </p>
        <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 rounded-xl bg-background-50 border border-background-200/70">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-smartphone-line text-2xl text-primary-500"></i>
          </div>
          <div className="text-left">
            <p className="text-foreground-800 font-medium text-sm">手机浏览器直接访问即可观看</p>
            <p className="text-foreground-500 text-xs mt-1">无需下载App，打开浏览器输入网址立即体验高清影视</p>
          </div>
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-5 py-2 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            立即体验
          </a>
        </div>
      </div>
    </section>
  );
}